import PropTypes from 'prop-types';
import { formatDistanceToNowStrict } from 'date-fns';
// material
import { styled } from '@material-ui/core/styles';
import { Avatar, Box, Stack, Typography } from '@material-ui/core';
import { decodeString } from '../../../utils/decodeString';
import { getFileFormat } from '../../../utils/getFileFormat';
import { Icon } from '@iconify/react';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  marginBottom: theme.spacing(3)
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 320,
  padding: theme.spacing(1.5),
  marginTop: theme.spacing(0.5),
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.background.neutral
}));

const InfoStyle = styled(Typography)(({ theme }) => ({
  display: 'flex',
  marginBottom: theme.spacing(0.75),
  color: theme.palette.text.secondary
}));

const MessageImgStyle = styled('img')(({ theme }) => ({
  height: "auto",
  // minWidth: 296,
  width: '100%',
  cursor: 'pointer',
  objectFit: 'cover',
  borderRadius: theme.shape.borderRadius
}));


// ----------------------------------------------------------------------

ChatMessageItem.propTypes = {
  itemMess: PropTypes.object.isRequired,
  onOpenLightbox: PropTypes.func
};

export default function ChatMessageItem({ infoUserSelected, itemMess, onOpenLightbox, ...other }) {
  const { type, message, from_id, to_id, from_display_name, page_id, to_avatar, from_avatar, to_display_name, attachments, url, time,attachment_temp_blob } = itemMess
  const { display_name, avatar } = infoUserSelected
  const senderDetails =
    from_id === page_id
      ? { type: 'me' }
      : { avatar: from_avatar, name: from_display_name };
  const isMe = senderDetails.type === 'me';
  const isImage = type === 'image';
  const isAudio = type === 'audio';
  const isFile = type === 'file';
  const firstName = senderDetails.name && senderDetails.name.split(' ')[0];
  return (
    <RootStyle {...other}>
      <Box
        sx={{
          display: 'flex',
          ...(isMe && {
            ml: 'auto'
          })
        }}
      >
        {senderDetails.type !== 'me' && (
          <Avatar alt={senderDetails.avatar} src={senderDetails.avatar} sx={{ width: 32, height: 32 }} />
        )}

        <Box sx={{ ml: 2 }}>
          <InfoStyle noWrap variant="caption" sx={{ ...(isMe && { justifyContent: 'flex-end' }) }}>
            {!isMe && `${firstName},`}&nbsp;
            {formatDistanceToNowStrict(new Date(time), {
              addSuffix: true
            })}
          </InfoStyle>

          <ContentStyle
            sx={{
              ...(isMe && {
                color: 'grey.800',
                bgcolor: 'primary.lighter'
              })
            }}
          >
            {attachments && attachments.map((attachment, index) => {
              if (attachment?.type === "sticker") {
                return <MessageImgStyle alt="attachment_image" src={attachment.payload.url} />
              }
              if (attachment?.type === "image" || attachment?.type.search("image") != -1) {
                return <MessageImgStyle alt="attachment_image" src={attachment?.payload ? attachment?.payload.url : URL.createObjectURL(attachment)} onClick={() => onOpenLightbox(attachment?.payload ? attachment?.payload.url : attachment_temp_blob)} />
              }
              if (attachment?.type === "audio") {
                return (
                  <audio alt="attachment_audio" controls>
                    <source src={attachment.payload.url} />
                  </audio>
                )
              }
              if (attachment?.type === "file" || (attachment?.name && ['word', 'excel', 'pdf'].includes(getFileFormat(attachment?.payload ? decodeString(new URL(attachment.payload.url).pathname.split('/').pop()) : decodeString(attachment.name))))) {
                return (
                  <Stack direction="row" spacing={0.5}>
                    {getFileFormat(attachment?.payload ? decodeString(new URL(attachment.payload.url).pathname.split('/').pop()) : decodeString(attachment.name)) === "word" && <Icon width={20} height={20} icon="vscode-icons:file-type-word" />}
                    {getFileFormat(attachment?.payload ? decodeString(new URL(attachment.payload.url).pathname.split('/').pop()) : decodeString(attachment.name)) === "excel" && <Icon width={20} height={20} icon="vscode-icons:file-type-excel" />}
                    {getFileFormat(attachment?.payload ? decodeString(new URL(attachment.payload.url).pathname.split('/').pop()) : decodeString(attachment.name)) === "pdf" && <Icon width={20} height={20} color="red" icon="iwwa:file-pdf" />}
                    {!['word', 'excel', 'pdf'].includes(getFileFormat(attachment?.payload ? decodeString(new URL(attachment.payload.url).pathname.split('/').pop()) : decodeString(attachment.name))) && <InsertDriveFileIcon ></InsertDriveFileIcon>}
                    <div><a href={attachment?.payload ? attachment?.payload.url : URL.createObjectURL(attachment)}>{attachment?.payload ? decodeString(new URL(attachment.payload.url).pathname.split('/').pop()) : decodeString(attachment.name)}</a></div>
                  </Stack>
                )
              }
            })
            }

            <Typography variant="body1">{decodeString(message)}</Typography>
          </ContentStyle>
        </Box>
      </Box>
    </RootStyle>
  );
}
